//import { useEffect } from 'react'
//import { GetGenderMode } from './../../../utilities/BL/Zones'


const Riddle = ({ riddle, isActiveWomensMode }) => {
    //const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)


    // const LoadPage = async () => {
    //     try {
    //         // const response = await GetGenderMode()

    //         // if (response.success) {
    //         //     setIsActiveWomensMode(response.data.isWomensModeActive)
    //         // } else {
    //         //     setIsActiveWomensMode(false)
    //         // }
    //     } catch (error) {
            
    //     }
    // }

    // useEffect(() => {
    //     LoadPage()
    // }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Riddle__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='Riddle__Screen__Background__Image' />
                )} */}

                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='Screen__Riddle__Background__Image' /> */}
                {/* <img src='/img/games/quizz/laboratorios-tequis/background-3.png' className='Riddle__Screen__Background__Image' /> */}
                <img src='/img/games/riddle/female/september-11-2026/background.png' className='Riddle__Screen__Background__Image' style={{ position: 'fixed', width: '100%', height: '100%' }} />
            </div>

            {/* Contenido */}
            <section className='Riddle__Screen__Box'>
                <p className='Riddle__Screen__Box__Title' style={{ fontFamily: '"GFS Didot", serif', textTransform: 'uppercase' }}>
                    {/* <img src='/img/page/adsl-five.png' className='FrontPage--Riddle__Screen__Container__Logo' style={{ maxWidth: '350px', marginBottom: '0' }} /> */}
                    <img src='/img/games/riddle/female/september-11-2026/Logo-optimo-blanco-768x320.png' className='FrontPage--Riddle__Screen__Container__Logo' style={{ maxWidth: '350px', marginBottom: '0' }} />
                    {riddle.instruction}
                </p>
                {/* <p className='Riddle__Screen__Box__Title' style={{ fontFamily: '"GFS Didot", serif', textTransform: 'uppercase' }}>ADIVINA ADIVINADOR...<br />¿QUIÉN SE ESCONDE EN LA SOMBRA?</p> */}
                {/* <p className='Riddle__Screen__Box__Title' style={{ fontFamily: '"GFS Didot", serif', textTransform: 'uppercase' }}>ADIVINA ADIVINADOR...<br />¿QUIÉN SOY?</p> */}
                
                {riddle.isItemVisible ? (
                    <div className='Riddle__Screen__Box__Container--Visible'>
                        <img src={riddle.response.image} className='Riddle__Screen__Box__Container--Visible__Image' />

                        <div className='Riddle__Screen__Box__Container--Visible__Response'>
                            <p className='Riddle__Screen__Box__Container--Visible__Response__Text' style={{ fontFamily: '"GFS Didot", serif', textTransform: 'uppercase' }}>{riddle.response.text}</p>
                            <img src='/img/games/riddle/flecha-blanca.png' className='Riddle__Screen__Box__Container--Visible__Response__Image' />
                        </div>
                    </div>
                ) : (
                    <div className='Riddle__Screen__Box__Container--Hidden'>
                        <img src={riddle.image} className='Riddle__Screen__Box__Container--Hidden__Image' />

                        <ul className='Riddle__Screen__Box__Container--Hidden__List'>
                            {riddle.options.map((option, index) => (
                                <li key={index} className='Riddle__Screen__Box__Container--Hidden__List__Item' style={{ fontFamily: '"GFS Didot", serif', textTransform: 'uppercase' }}>{option.text}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </section>

            {/* <aside className="Riddle__Screen__Brand">
                {/ <img src="/img/games/riddle/female/january-24-2026/provi-logotipo.png" className="Riddle__Screen__Brand__Logo" /> /}
                <img src="/img/page/adsl-five.png" className="Riddle__Screen__Brand__Logo" />
            </aside> */}

            {/* Pie de página */}
            <footer className='Riddle__Screen__Footer' style={{ zIndex: '2' }}>
                <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
            </footer>
        </>
    )
}

export { Riddle };





{/* <div className='Riddle__Screen'>
    <p className='Riddle__Screen__Title'>{riddle.instruction}</p>

    {riddle.isItemVisible ? (
        <div className='Riddle__Screen__Container--Visible'>
            <img src={riddle.response.image} className='Riddle__Screen__Container--Visible__Image' />

            <div className='Riddle__Screen__Container--Visible__Response'>
                <p className='Riddle__Screen__Container--Visible__Response__Text'>{riddle.response.text}</p>
                <img src='/img/games/riddle/flecha-blanca.png' className='Riddle__Screen__Container--Visible__Response__Image' />
            </div>
        </div>
    ) : (
        <div className='Riddle__Screen__Container--Hidden'>
            <img src={riddle.image} className='Riddle__Screen__Container--Hidden__Image' />

            <ul className='Riddle__Screen__Container--Hidden__List'>
                {riddle.options.map((option, index) => (
                    <li key={index} className='Riddle__Screen__Container--Hidden__List__Item'>{option.text}</li>
                ))}
            </ul>
        </div>
    )}
</div>

<footer className='Riddle__Screen__Footer'>
    Hecho con ♥ por Interaktia | 2026
</footer> */}